import { combineReducers } from 'redux';
import types from './types';

export const location = (state = {
  item: null,
  loading: false,
  error: null,
}, action) => {
  // console.log('::::::REDUCER::LOCATIONS::location::', action);
  switch (action.type) {
    case types.GET_REQUEST:
    case types.SAVE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_FAILURE:
    case types.SAVE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.SAVE_SUCCESS:
      return {
        ...state,
        item: action.payload.data,
        loading: false,
        error: null,
      };
    case types.GET_SUCCESS:
      return {
        ...state,
        item: action.payload.data,
        loading: false,
        error: null,
      };
    case types.CLEAR_CURRENT:
      return {
        ...state,
        item: null,
      }
    default:
      return state
  }
}


export const locations = (state = {
  loading: false,
  items: [],
  error: null,
}, action) => {
  // console.log('::::::REDUCER::LOCATIONS::locations::', action);
  switch (action.type) {
    case types.GETALL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GETALL_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.data,
        query: action.payload.query
      };
    case types.GETALL_FAILURE:
      return { 
        ...state,
        loading: false,
        error: action.error
      };
    case types.DELETE_REQUEST:
      return {
        ...state,
        items: state.items.map(item =>
          item.id === action.id
            ? { ...item, deleting: true }
            : item
        )
      };
    case types.DELETE_SUCCESS:
      // remove deleted item from state
      return {
        ...state,
        error: null,
        items: state.items.filter(item => item.id !== action.id)
      };
    case types.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to item 
      return {
        ...state,
        error: action.error,
      };
    default:
      return state
  }
}


export default combineReducers({
  current: location,
  list: locations
});

